"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var page_header_footer_modal_html_1 = __importDefault(require("./page-header-footer-modal.html"));
require("./page-header-footer-modal.less");
(function (angularModule) {
    angularModule.factory('prPageHeaderFooterModal', [
        '$rootScope',
        '$filter',
        '$templateCache',
        'qstrap.modal',
        function ($rootScope, $filter, 
        // @ts-ignore
        $templateCache, 
        // @ts-ignore
        modal) {
            var translate = $filter('translate');
            function show(type) {
                var scope = $rootScope.$new();
                scope.type = type;
                modal({
                    show: true,
                    scope: scope,
                    controller: 'prPageHeaderFooterModalController',
                    title: translate(type.toUpperCase()),
                    contentTemplate: page_header_footer_modal_html_1.default,
                    buttons: [
                        '<button class="btn btn-success" ng-click="$ctrl.save(); close();" ng-disabled="$ctrl.isSaveButtonDisabled()">' +
                            translate('SAVE') + '</button>', '<button class="btn btn-hover" ng-click="close()">' +
                            translate('CLOSE') + '</button>'
                    ]
                });
            }
            return {
                show: show
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
